var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hStack",style:({'flex-wrap':_vm.flexWrap, 'justify-content': _vm.justifyContent,'align-items': _vm.alignItems, 'flex-direction':_vm.flexDirection})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }